import { backToTop } from "./util";

const BackToTop = (() => {
    return {
        init() {
            backToTop($('.js-back-top'));
        }
    }
})();

export default (() => {
    $(document).ready(BackToTop.init);
})();
